<template>
  <section class="app-main"  style="overflow: hidden">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path;
    }
  },
}
</script>

<style lang="scss" scoped>
  .el-popup-parent--hidden {
    .fixed-header {
      padding-right: 15px;
    }
  }
.app-main {
  width: 100%;
  position: relative;
  min-height: calc(100vh - 90px);
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>




// WEBPACK FOOTER //
// src/layout/components/AppMain.vue